/**
 * Sentinel an edit-modal `submit` handler can resolve with to signal that the save flow
 * continues in a follow-up modal owned by the caller (e.g. the shared-email "designate a
 * new primary contact" step, OP-5804). The edit modal then stops silently: no close, no
 * success toast, no `updated` emit — the caller finishes (or abandons) the write itself
 * and closes the edit modal through its `v-model` when done.
 */
export const DEFERRED_SUBMIT = Symbol('deferred-submit');
